module.exports = __webpack_public_path__ + "img/type-sample.6fa7b120.svg";